var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { space, position, layout, typography, color, flexbox, border, shadow, } from "styled-system";
export var TextInput = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  outline: 0;\n  padding: 0.3em;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  outline: 0;\n  padding: 0.3em;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), space, position, layout, typography, color, flexbox, border, shadow);
TextInput.defaultProps = {
    borderLeft: 0,
    borderRight: 0,
    borderTop: 0,
    borderBottom: "1px solid rgba(0,0,0,0.2)",
};
var templateObject_1;
//# sourceMappingURL=TextInput.js.map